import axios from 'axios'
import {FeatureConfig} from '@/utils/constants/featuresFlag'
import {attachAuthInterceptor} from '@/core/interceptors/authInterceptor'
import {attachErrorInterceptor} from '@/core/interceptors/errorInterceptor'
import {HTTP_METHODS} from '@/utils/constants/httpMethods'
import {API_VERSION} from '@/utils/constants/commonConstants'
import {Constants} from '@/utils/constants/commonConstants'

const apiClient = axios.create({
  baseURL: import.meta.env[FeatureConfig.apiUrl],
  timeout: 5000,
})

// Attach interceptors
attachAuthInterceptor(apiClient)
attachErrorInterceptor(apiClient)

const getMockData = async config => {
  const method = config?.method || HTTP_METHODS.GET
  if (method === HTTP_METHODS.GET && config?.mockData) {
    return config?.mockData
  }
  if (method === HTTP_METHODS.GET && config?.mockPath) {
    const mockData = await import(config.mockPath)
    return mockData.default || {}
  }
  return {}
}

export const request = async (config, options = {}, queryParams = '') => {
  const method = config?.method || HTTP_METHODS.GET

  let endPoint = `${config?.version || API_VERSION.V1}/${config.endPoint}`

  // If method is GET and ids are provided, add them as query params
  if (method === HTTP_METHODS.GET && queryParams) {
    endPoint = `${endPoint}?${queryParams}` // Append query params to the URL
  }

  // If method is Post and params are provided, add them as query params
  if (method === HTTP_METHODS.POST && queryParams && config?.multipart === Constants.Multipart) {
    endPoint = `${endPoint}?${queryParams}` // Append query params to the URL
  }

  const defaultOptions = {
    method,
    url: endPoint,
    headers: {
      'Content-Type': config?.contentType || 'application/json',
      ...config?.headers,
    },
    ...options,
  }

  let response = {}
  try {
    response = await apiClient(defaultOptions)
  } catch (err) {
    console.error(err)
    const mockRes = await getMockData(config)
    return mockRes
  }
  return response?.data
}
